import {index} from './module/index';

const routes=[
    ...index,
   
]

export default routes